<template>
  <MobileNavigation ></MobileNavigation>
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 bg-slate-900" style="height:100%">

    <div id="container">
      <div class="menu-box">
        <div class="grid grid-cols-2 gap-5  text-center boxes-container">
      <div class="box w-40 h-40 rounded-lg bg-black text-white text-center" v-on:click="openPunchMap">
        <i class="fas fa-map-marked text-2xl mt-5"></i>
        <br>
        Punch
      </div>
      <a v-bind:href="'/app/paytime/attendance-leaves-summary'" class="box w-40 h-40 rounded-lg text-center bg-black text-white no-decoration" >
        <i class="fas fa-calendar-check text-2xl mt-5"></i>
        <br>
        Attendance &amp; Leaves
      </a>
      <a v-bind:href="'/app/paytime/your-expenses'" class="box w-40 h-40 rounded-lg text-center bg-black text-white no-decoration" >
        <i class="fas fa-calendar-check text-2xl mt-5"></i>
        <br>
        Expenses
      </a>
      <a v-bind:href="'/subscription'" class="box w-40 h-40 rounded-lg text-center bg-black text-white no-decoration" >
        <i class="fas fa-user-check text-2xl mt-5"></i>
        <br>
        Self Service
      </a>

    </div>
    
      </div>
    </div>

      
    </div>    
</template>
<style scoped>
    .noselect {
        -webkit-touch-callout: none;
        /* iOS Safari */
        -webkit-user-select: none;
        /* Safari */
        -khtml-user-select: none;
        /* Konqueror HTML */
        -moz-user-select: none;
        /* Firefox */
        -ms-user-select: none;
        /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
    }


    .no-decoration{
      text-decoration: none;
    }

    .no-decoration:hover{
      text-decoration: none;
    }

#container {
  width: 100%;
  height: 100%;
  margin-top: 20%;
/* --- FLEX --- */
  display: flex;
  justify-content: center;
  align-items: center;
}

.menu-box {
  width: 100%;
  height: 100%;
  font-size: 20px;
  color: #333;
  text-align: center;
  border-radius: 3px;
  display: inherit;
  justify-content: inherit;
  align-items: inherit;
  transition: all 0.5s ease;
}

    </style>

<script>
import MobileNavigation from "@/Layouts/MobileNavigation.vue";
import Welcome from "@/Jetstream/Welcome.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from '@/Jetstream/NavLink.vue'


export default {
  props: ["sessions"],

  components: {
    MobileNavigation,
    Welcome,
    PageTitle,
    JetNavLink,

  },
  data() {
    return {
      title: "Attendance Menu",
      username: null,
      password: null,

    };
  },
  methods: {
    getOrganisation() {
      axios.get("tenants/list").then((response) => {
      });
    },
    openPunchMap(){
      app.startPunchMap();
    },
     getCoordinates(coordinates){
       alert(coordinates);
      }
  },
  mounted() {
    this.getOrganisation();
    this.showBackButton();
  },
};
</script>
